import { inject } from 'mobx-react';

const withLocationPersistence = (WrappedComponent, attributes) => {
    @inject('routing', 'mapStore')
    class boundComponent extends WrappedComponent {
        constructor(props) {
            super(props);
            
            this.state = {...this.state};
            
            this.updateStateAndLocationAttribute = this.updateStateAndLocationAttribute.bind(this);
        }

        // convert our query string back into a state object
        componentDidMount() {
            let query = new URLSearchParams(this.props.routing.location.search);
            let params = {};
            for(let entry of query) {
                const [key, value] = entry;
                params[key] = value;
            }

            this.setState(params);

            if( typeof super.componentDidMount !== 'undefined' ) {
                super.componentDidMount(arguments);
            }
        }

        // just update the state
        updateState(event) {
            const {name, value} = event.currentTarget;

            let state = {
                [name]: value
            };

            this.setState(state);
        }

        updateLocationAttribute(event) {
            const {name, value} = event.currentTarget;

            let query = new URLSearchParams(this.props.routing.location.search);
            query.set(name, value);
            
            this.props.routing.location.search = query.toString();
            this.props.routing.replace(`?${query.toString()}`);            
        }

        // take otherwise local state attributes and store them in the query string
        updateStateAndLocationAttribute(event) {
            this.updateLocationAttribute(event);
            this.updateState(event);
            // const {name, value} = event.currentTarget;
            
            // let state = {};
            // state[name] = value;

            // let query = new URLSearchParams(this.props.routing.location.search);
            // query.set(name, value);
            
            // this.props.routing.location.search = query.toString();
            // this.props.routing.replace(`?${query.toString()}`);
            
            // this.setState(state);
        }

        render() {
            return super.render();
        }
    }
    
    return boundComponent;
}

export default withLocationPersistence;
